<template>
  <modal
    :size="'xl'"
    :title="
      setModel > 0
        ? 'Update Customer Hotel (' +
          (hotels != null
            ? hotels.filter((x) => {
                return x.Id == model.Id;
              })[0].Name
            : '') +
          ')'
        : 'Add Customer Hotel'
    "
    @close="$emit('close')"
  >
    <template #content>
      <loadArea
        v-if="hotels == null || softwares == null || countries == null || load"
      ></loadArea>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-1rem row align-items-start"
        ref="form"
        v-if="hotels != null && softwares != null && countries != null && !load"
      >
        <div class="col-md-6">
          <formGroup
            :title="'Country'"
            :as="'select'"
            v-model="countryId"
            :disabled="softwares.length == 0"
            :errors="errors"
            @change="
              model.HotelId = '';
              searchHotel = '';
            "
            @keydown.enter="save"
          >
            <template #input>
              <option
                v-for="item in countries"
                :value="item.Id"
                :key="item.Code"
                >{{ item.Name }}</option
              >
            </template>
          </formGroup>
          <selectBox
            :title="'HotelId'"
            v-model.number="model.HotelId"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
            v-if="setModel == 0"
          >
            <template #search>
              <input
                type="text"
                placeholder="Ara"
                class="form-control small"
                v-model="searchHotel"
              />
            </template>
            <template #input>
              <template v-for="item in hotels">
                <option
                  :value="item.Id"
                  :key="item.Id"
                  v-if="
                    searchHotel.length < 3 ||
                      item.Name.toUpperCase().indexOf(
                        searchHotel.toUpperCase()
                      ) > -1
                  "
                  >{{ item.Name }}</option
                >
              </template>
            </template>
          </selectBox>
          <div class="row">
            <div class="col-6">
              <formGroup
                :title="'RoomCount'"
                type="number"
                v-model.number="model.RoomCount"
                :errors="errors"
                :rules="{ required: true }"
                @keydown.enter="save"
                :buttons="setModel != 0"
                :disabled="refleshRoomCountProcess"
              >
                <template v-if="setModel != 0" #buttons>
                  <Btn
                    class="btn waves-effect waves-light btn-success"
                    @click="refleshRoomCount()"
                    :process="refleshRoomCountProcess"
                    ><i class="fas fa-sync-alt"></i
                  ></Btn>
                </template>
              </formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="'ChildPercentage'"
                v-model.number="model.ChildPercentage"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
          </div>
          <div class="row" style="margin:0 -5px">
            <div class="col-6" style="padding: 0 5px;">
              <formGroup
                :title="'EnterHour'"
                v-model.number="model.EnterHour"
                :errors="errors"
                :rules="{ max_value: 23 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6" style="padding: 0 5px;">
              <formGroup
                :title="'EnterMinute'"
                v-model.number="model.EnterMinute"
                :errors="errors"
                :rules="{ max_value: 59 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6" style="padding: 0 5px;">
              <formGroup
                :title="'ExitHour'"
                v-model.number="model.ExitHour"
                :errors="errors"
                :rules="{ max_value: 23 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6" style="padding: 0 5px;">
              <formGroup
                :title="'ExitMinute'"
                v-model.number="model.ExitMinute"
                :errors="errors"
                :rules="{ max_value: 59 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
          </div>
          <div class="row m-0">
            <div class="col-4 p-0">
              <formGroup
                :title="'A.HourTo'"
                :as="'select'"
                v-model.number="model.ArrivalHourTo"
                :errors="errors"
                @keydown.enter="save"
              >
                <template #input>
                  <option :value="0">İşlem Yapma</option>
                  <option :value="1">Check In/Out</option>
                  <option
                    :value="2"
                    v-if="model.SoftwareId == 5 || model.SoftwareId == 11"
                  >
                    Geliş/Gidiş
                  </option>
                  <option :value="2" v-if="model.SoftwareId == 3">
                    (U/O) Geliş/Ayrılış S
                  </option>
                  <option :value="2" v-if="model.SoftwareId == 15">
                    Arrival/Departure
                  </option>
                </template>
              </formGroup>
            </div>
            <div class="col-4 p-0">
              <formGroup
                :title="'A.ArrivalHour'"
                style="border-left:none;"
                v-model.number="model.AddinationalArrivalHour"
                :errors="errors"
                :rules="{ max_value: 23 }"
                @keydown.enter="save"
                :disabled="model.ArrivalHourTo == 0"
              ></formGroup>
            </div>
            <div class="col-4 p-0">
              <formGroup
                :title="'A.ArrivalMinute'"
                style="border-left:none;"
                v-model.number="model.AddinationalArrivalMinute"
                :errors="errors"
                :rules="{ max_value: 59 }"
                @keydown.enter="save"
                :disabled="model.ArrivalHourTo == 0"
              ></formGroup>
            </div>
            <div class="col-4 p-0">
              <formGroup
                :title="'D.HourTo'"
                :as="'select'"
                v-model.number="model.DepartureHourTo"
                :errors="errors"
                @keydown.enter="save"
              >
                <template #input>
                  <option :value="0">İşlem Yapma</option>
                  <option :value="1">Check In/Out</option>
                  <option
                    :value="2"
                    v-if="model.SoftwareId == 5 || model.SoftwareId == 11"
                  >
                    Geliş/Gidiş
                  </option>
                  <option :value="2" v-if="model.SoftwareId == 3">
                    (U/O) Geliş/Ayrılış S
                  </option>
                  <option :value="2" v-if="model.SoftwareId == 15">
                    Arrival/Departure
                  </option>
                </template>
              </formGroup>
            </div>
            <div class="col-4 p-0">
              <formGroup
                :title="'A.DepartureHour'"
                style="border-left:none;"
                v-model.number="model.AddinationalDepartureHour"
                :errors="errors"
                :rules="{ max_value: 23 }"
                :disabled="model.DepartureHourTo == 0"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-4 p-0">
              <formGroup
                :title="'A.DepartureMinute'"
                style="border-left:none;"
                v-model.number="model.AddinationalDepartureMinute"
                :errors="errors"
                :rules="{ max_value: 59 }"
                :disabled="model.DepartureHourTo == 0"
                @keydown.enter="save"
              ></formGroup>
            </div>
          </div>

          <formGroup
            :title="'CustomConfig'"
            v-model="model.CustomConfig"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
          <template v-if="model.SoftwareId == 6 || model.SoftwareId == 11">
            <formGroup
              :title="'FileNameFormat'"
              v-model="model.FileNameFormat"
              :errors="errors"
              @keydown.enter="save"
            ></formGroup>
            <small style="font-size:65%; display:block; margin-top:-5px;">
              <b style="font-weight:600">Fields:</b> KNO, Voucher, Checkin,
              Checkout, SaleDate, yy, yyyy, MM, dd, HH, mm, ss,
              ReservationStatus
            </small>
            <small style="font-size:65%; display:block; margin-bottom:16px;">
              <b style="font-weight:600">Sample:</b>
              {KNO}-{ReservationStatus}-{dd}{MM}{yy}-{HH}{mm}{ss}
            </small>
          </template>
          <formGroup
            :title="'RemoveOldReservationsHour'"
            type="number"
            v-model="model.RemoveOldReservationsHour"
            :disabled="!model.RemoveOldReservations"
            :checkDisabled="true"
            :errors="errors"
            @keydown.enter="save"
          >
            <template #checkDisabled>
              <formGroup
                as="checkbox"
                v-model="model.RemoveOldReservations"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </template>
          </formGroup>
          <div class="card m-b-10 p-10">
            <div
              class="card-header p-t-0 p-l-0 p-r-0"
              :class="model.AgeCalculation ? ' p-b-5' : 'p-b-0'"
            >
              <formGroup
                :title="'AgeCalculation'"
                :as="'checkbox'"
                v-model="model.AgeCalculation"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>

            <div class="collapse show" v-if="model.AgeCalculation">
              <div class="card-header p-0">
                <div class="row m-0">
                  <div class="col-6 p-0">
                    <formGroup
                      :title="'Adult Age From'"
                      as="select"
                      v-model="model.AdultAgeFrom"
                      :disabled="!model.AdultAgeEdit"
                      :checkDisabled="true"
                      :errors="errors"
                      @keydown.enter="save"
                    >
                      <template #checkDisabled>
                        <formGroup
                          as="checkbox"
                          v-model="model.AdultAgeEdit"
                          :errors="errors"
                          @keydown.enter="save"
                        ></formGroup>
                      </template>
                      <template #input>
                        <option value="checkin">Checkin</option>
                        <option value="checkout">Checkout</option>
                        <option value="sale">Sale</option>
                      </template>
                    </formGroup>
                  </div>
                  <div class="col-6 p-0">
                    <formGroup
                      :title="'Adult Age From Days'"
                      type="number"
                      style="border-left:none"
                      v-model.number="model.AdultAgeFromDays"
                      :disabled="!model.AdultAgeEdit"
                      :errors="errors"
                      :rules="{ max_value: 59 }"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                </div>
                <div class="row m-0">
                  <div class="col-6 p-0">
                    <formGroup
                      :title="'Child Age From'"
                      as="select"
                      v-model="model.ChildAgeFrom"
                      :disabled="!model.ChildAgeEdit"
                      :checkDisabled="true"
                      :errors="errors"
                      @keydown.enter="save"
                      class="m-b-0"
                    >
                      <template #checkDisabled>
                        <formGroup
                          as="checkbox"
                          v-model="model.ChildAgeEdit"
                          :errors="errors"
                          @keydown.enter="save"
                        ></formGroup>
                      </template>
                      <template #input>
                        <option value="checkin">Checkin</option>
                        <option value="checkout">Checkout</option>
                        <option value="sale">Sale</option>
                      </template>
                    </formGroup>
                  </div>
                  <div class="col-6 p-0">
                    <formGroup
                      :title="'Child Age From Days-'"
                      type="number"
                      style="border-left:none"
                      v-model.number="model.ChildAgeFromDays"
                      :disabled="!model.ChildAgeEdit"
                      :errors="errors"
                      :rules="{ max_value: 59 }"
                      @keydown.enter="save"
                    ></formGroup>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <formGroup
            :title="'Auto Repeat'"
            :as="'checkbox'"
            v-model="model.AutoRepeat"
            :errors="errors"
          >
          </formGroup>
          <formGroup
            :title="'Check Repeat'"
            :as="'checkbox'"
            v-model="model.CheckRepeat"
            :errors="errors"
          >
          </formGroup>
          <formGroup
            :title="'Order Person Names'"
            :as="'checkbox'"
            v-model="model.OrderPersonNames"
            :errors="errors"
          >
          </formGroup>
          <formGroup
            v-if="model.SoftwareId == 5 || model.SoftwareId == 11"
            :title="'Auto Country Selection'"
            as="checkbox"
            v-model="model.AutoCountrySelection"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            v-if="model.SoftwareId == 5 || model.SoftwareId == 11"
            :title="'Show Discount Code'"
            as="checkbox"
            v-model="model.ShowDiscountCode"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Sale Clock'"
            as="checkbox"
            v-model="model.SaleClock"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Order Contract'"
            as="checkbox"
            v-model="model.OrderContract"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Send Approve Before Save'"
            as="checkbox"
            v-model="model.SendApproveBeforeSave"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Send Approve After Save'"
            as="checkbox"
            v-model="model.SendApproveAfterSave"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Wait Approve Save PMS'"
            as="checkbox"
            v-model="model.WaitApproveSavePMS"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Wait Approve Confirm Agency'"
            as="checkbox"
            v-model="model.WaitApproveConfirmAgency"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Use Stop Sale'"
            as="checkbox"
            v-model="model.UseStopSale"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Write Confirmed Document'"
            as="checkbox"
            v-model="model.WriteConfirmedDocument"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Save Confirmed Document'"
            as="checkbox"
            v-model="model.SaveConfirmedDocument"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            v-if="model.SoftwareId == 13"
            :title="'Use Perspeciva'"
            as="checkbox"
            v-model="model.UsePerspectiva"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Group Check Repeat'"
            as="checkbox"
            v-model="model.GroupCheckRepeat"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'Auto Save'"
            as="checkbox"
            v-model="model.AutoSave"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            :title="'PdfDownload'"
            :as="'checkbox'"
            v-model="model.PdfDownload"
            :errors="errors"
            @keydown.enter="save"
            v-if="model.SoftwareId == 3"
          ></formGroup>
        </div>
        <div class="col-md-6 border-left">
          <formGroup
            :title="'SoftwareId'"
            :as="'select'"
            v-model="model.SoftwareId"
            :disabled="softwares.length == 0 || !model.PMSIntegration"
            :buttons="true"
            :checkDisabled="true"
            :errors="errors"
            @keydown.enter="save"
          >
            <template #checkDisabled>
              <formGroup
                as="checkbox"
                v-model="model.PMSIntegration"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </template>
            <template #input>
              <option
                v-for="item in softwares"
                :value="item.Id"
                :key="item.Code"
                >{{ item.Name }}</option
              >
            </template>
            <template #buttons>
              <button
                type="button"
                @click="addSoftwareOpen = true"
                class="btn waves-effect waves-light btn-success"
              >
                <i class="fas fa-plus"></i>
              </button>
            </template>
          </formGroup>
          <div class="row">
            <div class="col-6">
              <formGroup
                :title="setParamterText('P1')"
                v-model="model.P1"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P2')"
                v-model="model.P2"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P3')"
                v-model="model.P3"
                :errors="errors"
                :rules="{ max: 4000 }"
                v-if="model.SoftwareId != 16"
                @keydown.enter="save"
              ></formGroup>
              <formGroup
                :title="setParamterText('P3')"
                v-model="model.P3"
                :errors="errors"
                as="select"
                :disabled="veboniProperties.length==0"
                v-if="model.SoftwareId == 16"
                @keydown.enter="save"
              >
                <template #input>
                  <option :value="item.RecId" v-for="item in veboniProperties" :key="item.RecId">{{item.PropertyName}}</option>
                </template>
              </formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P4')"
                v-model="model.P4"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P5')"
                v-model="model.P5"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P6')"
                v-model="model.P6"
                :errors="errors"
                :rules="{ max: 4000 }"
                :buttons="model.SoftwareId == 5 || model.SoftwareId == 11"
                @keydown.enter="save"
                :as="
                  model.SoftwareId == 5 || model.SoftwareId == 11
                    ? 'select'
                    : 'input'
                "
                :disabled="sednaCompaniesLoad"
              >
                <template #input>
                  <option
                    v-for="item in sednaCompanies"
                    :value="item.RecId"
                    :key="item.RecId"
                    >{{ item.Name }}</option
                  >
                </template>
                <template
                  v-if="model.SoftwareId == 5 || model.SoftwareId == 11"
                  #buttons
                >
                  <Btn
                    class="btn waves-effect waves-light btn-success"
                    @click="getSednaCompanies()"
                    :process="sednaCompaniesLoad"
                    ><i class="fas fa-sync-alt"></i
                  ></Btn>
                </template>
              </formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P7')"
                v-model="model.P7"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
                :buttons="model.SoftwareId == 5 || model.SoftwareId == 11"
                :as="
                  model.SoftwareId == 5 || model.SoftwareId == 11
                    ? 'select'
                    : 'input'
                "
                :disabled="sednaCompaniesLoad"
              >
                <template #input>
                  <option
                    v-for="item in sednaCompanies"
                    :value="item.CompanyCode"
                    :key="item.CompanyCode"
                    >{{ item.CompanyCode }}</option
                  >
                </template>
                <template
                  v-if="model.SoftwareId == 5 || model.SoftwareId == 11"
                  #buttons
                >
                  <Btn
                    class="btn waves-effect waves-light btn-success"
                    @click="getSednaCompanies()"
                    :process="sednaCompaniesLoad"
                    ><i class="fas fa-sync-alt"></i
                  ></Btn>
                </template>
              </formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P8')"
                v-model="model.P8"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P9')"
                v-model="model.P9"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P10')"
                v-model="model.P10"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P11')"
                v-model="model.P11"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P12')"
                v-model="model.P12"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P13')"
                v-model="model.P13"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P14')"
                v-model="model.P14"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P15')"
                v-model="model.P15"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P16')"
                v-model="model.P16"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P17')"
                v-model="model.P17"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P18')"
                v-model="model.P18"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P19')"
                v-model="model.P19"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="setParamterText('P20')"
                v-model="model.P20"
                :errors="errors"
                :rules="{ max: 4000 }"
                @keydown.enter="save"
              ></formGroup>
            </div>
          </div>
          <div class="row" v-if="model.SoftwareId == 11">
            <div class="col-6">
              <formGroup
                :title="'Quota Type'"
                :as="'select'"
                v-model.number="model.QuotaType"
                :errors="errors"
                @keydown.enter="save"
              >
                <template #input>
                  <option :value="0">İşlem Yapma</option>
                  <option :value="1">Single</option>
                  <option :value="2">Double</option>
                  <option :value="3">Single/Double</option>
                  <option :value="4">Total</option>
                </template>
              </formGroup>
            </div>
            <div class="col-6">
              <formGroup
                :title="'Default Quota Market'"
                :as="'select'"
                v-model.number="model.DefaultQuotaMarket"
                :errors="errors"
                @keydown.enter="save"
              >
                <template #input>
                  <option :value="1">Market Koduna Göre</option>
                  <option :value="2">Bütün Marketlere Göre</option>
                </template>
              </formGroup>
            </div>
          </div>
          <formGroup
            :title="'TempReservationCode'"
            v-model="model.TempReservationCode"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
          <formGroup
            v-if="model.SoftwareId == 6"
            :title="'TempGuestCode'"
            v-model="model.TempGuestCode"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
          <div class="row">
            <div class="col">
              <formGroup
                :title="'Mr'"
                v-model="model.Mr"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col">
              <formGroup
                :title="'Mrs'"
                v-model="model.Mrs"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col">
              <formGroup
                :title="'Chd'"
                v-model="model.Chd"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
            <div class="col">
              <formGroup
                :title="'Inf'"
                v-model="model.Inf"
                :errors="errors"
                @keydown.enter="save"
              ></formGroup>
            </div>
          </div>
          <formGroup
            v-if="
              model.SoftwareId == 1 ||
                model.SoftwareId == 2 ||
                model.SoftwareId == 3 ||
                model.SoftwareId == 5 ||
                model.SoftwareId == 6 ||
                model.SoftwareId == 7 ||
                model.SoftwareId == 9 ||
                model.SoftwareId == 11 ||
                model.SoftwareId == 12 ||
                model.SoftwareId == 13 ||
                model.SoftwareId == 14 ||
                model.SoftwareId == 16
            "
            as="select"
            :title="'KolayrezNotesTo'"
            v-model="model.KolayrezNotesTo"
            :errors="errors"
            :rules="{ required: true }"
          >
            <template #input>
              <template v-if="model.SoftwareId == 1 || model.SoftwareId == 2">
                <option value="checkin">CheckIn</option>
                <option value="room">Oda</option>
                <option value="checkout">C.Out</option>
                <option value="annotation">Ek No</option>
              </template>
              <template v-if="model.SoftwareId == 3">
                <option value="checkin">Check In Notu</option>
                <option value="coutnotu">Check Out Notu</option>
              </template>
              <template v-if="model.SoftwareId == 5 || model.SoftwareId == 11">
                <option value="Remark">Remark</option>
                <option value="CheckinRemark">C/In</option>
                <option value="CheckOutRemark">C/Out</option>
                <option value="BlockingRemark">Blocking</option>
                <option value="FolioRemark">Folio</option>
                <option value="ResRemark">Res</option>
                <option value="PaymentRemark">Payment</option>
              </template>
              <template v-if="model.SoftwareId == 6">
                <option value="checkin">CheckIn</option>
                <option value="room">Oda Notu</option>
                <option value="checkout">C.Out</option>
                <option value="extraistek">Extra İstek</option>
                <option value="reznotu">Rez Notu</option>
                <option value="konfirmasyon">Konfirmasyon</option>
                <option value="iptalnotu">İptal Notu</option>
                <option value="odemenotu">Ödeme Notu</option>
                <option value="fiyatnotu">Fiyat Notu</option>
                <option value="faturaaciklama">Fatura Açıklama</option>
                <option value="genelnotlar">Genel Notlar</option>
                <option value="girisertelenedi">Giriş Ertelenedi</option>
                <option value="cikisertelenedi">Çıkış Ertelenedi</option>
                <option value="erkengirisnotu">Erken Giriş Notu</option>
                <option value="erkencikisnotu">Erken Çıkış Notu</option>
                <option value="upgradedowngradenedeni"
                  >Upgrade/Downgrade Nedeni</option
                >
              </template>
              <template v-if="model.SoftwareId == 7">
                <option value="aciklama">Açıklama</option>
                <option value="aciklama2">Açıklama 2</option>
              </template>
              <template v-if="model.SoftwareId == 9">
                <option value="R">Rezervasyon</option>
                <option value="O">Ön Büro</option>
                <option value="C">Check/Out</option>
                <option value="H">HK</option>
                <option value="W1">Konum Notu</option>
                <option value="P">CRM</option>
                <option value="D">Devremülk</option>
                <option value="W">WEB(Online)</option>
                <option value="R1">K. Uyuşmazlık</option>
                <option value="J">Dock Kontrol</option>
                <option value="U1">Fatura</option>
              </template>
              <template v-if="model.SoftwareId == 12">
                <option value="Note1">Not 1</option>
                <option value="Note2">Not 2</option>
              </template>
              <template v-if="model.SoftwareId == 13">
                <option value="BillingInfo">Billing Info</option>
                <option value="Remarks">Remarks</option>
              </template>
              <template v-if="model.SoftwareId == 14">
                <option value="Remark">Remark</option>
                <option value="CheckInRemark">CheckInRemark</option>
                <option value="CheckOutRemark">CheckOutRemark</option>
                <option value="BlockageRemark">BlockageRemark</option>
                <option value="FolioRemark">FolioRemark</option>
              </template>
              <template v-if="model.SoftwareId == 16">
                <option value="Remark">Remark</option>
                <option value="CheckInRemark">CheckInRemark</option>
                <option value="CheckOutRemark">CheckOutRemark</option>
                <option value="BlockageRemark">BlockageRemark</option>
                <option value="FolioRemark">FolioRemark</option>
              </template>
            </template>
          </formGroup>
          <div class="row">
            <div class="col">
              <formGroup
                v-if="
                  model.SoftwareId == 1 ||
                    model.SoftwareId == 2 ||
                    model.SoftwareId == 3 ||
                    model.SoftwareId == 5 ||
                    model.SoftwareId == 6 ||
                    model.SoftwareId == 7 ||
                    model.SoftwareId == 9 ||
                    model.SoftwareId == 11 ||
                    model.SoftwareId == 12 ||
                    model.SoftwareId == 13 ||
                    model.SoftwareId == 14 ||
                    model.SoftwareId == 16
                "
                as="select"
                :title="'ChildAgesNotesTo'"
                v-model="model.ChildAgesNotesTo"
                :errors="errors"
                @keydown.enter="save"
                style="margin-bottom:-10px;"
              >
                <template #input>
                  <template
                    v-if="model.SoftwareId == 1 || model.SoftwareId == 2"
                  >
                    <option value="null">Çocuk Yaşı Yazma</option>
                    <option value="checkin">CheckIn</option>
                    <option value="room">Oda</option>
                    <option value="checkout">C.Out</option>
                    <option value="annotation">Ek No</option>
                  </template>
                  <template v-if="model.SoftwareId == 3">
                    <option value="null">Çocuk Yaşı Yazma</option>
                    <option value="checkin">Check In Notu</option>
                    <option value="coutnotu">Check Out Notu</option>
                  </template>
                  <template
                    v-if="model.SoftwareId == 5 || model.SoftwareId == 11"
                  >
                    <option value="null">Çocuk Yaşı Yazma</option>
                    <option value="Remark">Remark</option>
                    <option value="CheckinRemark">C/In</option>
                    <option value="CheckOutRemark">C/Out</option>
                    <option value="BlockingRemark">Blocking</option>
                    <option value="FolioRemark">Folio</option>
                    <option value="ResRemark">Res</option>
                    <option value="PaymentRemark">Payment</option>
                  </template>
                  <template v-if="model.SoftwareId == 6">
                    <option value="null">Çocuk Yaşı Yazma</option>
                    <option value="checkin">CheckIn</option>
                    <option value="room">Oda Notu</option>
                    <option value="checkout">C.Out</option>
                    <option value="extraistek">Extra İstek</option>
                    <option value="reznotu">Rez Notu</option>
                    <option value="konfirmasyon">Konfirmasyon</option>
                    <option value="iptalnotu">İptal Notu</option>
                    <option value="odemenotu">Ödeme Notu</option>
                    <option value="fiyatnotu">Fiyat Notu</option>
                    <option value="faturaaciklama">Fatura Açıklama</option>
                    <option value="genelnotlar">Genel Notlar</option>
                    <option value="girisertelenedi">Giriş Ertelenedi</option>
                    <option value="cikisertelenedi">Çıkış Ertelenedi</option>
                    <option value="erkengirisnotu">Erken Giriş Notu</option>
                    <option value="erkencikisnotu">Erken Çıkış Notu</option>
                    <option value="upgradedowngradenedeni"
                      >Upgrade/Downgrade Nedeni</option
                    >
                  </template>
                  <template v-if="model.SoftwareId == 7">
                    <option :value="null">Çocuk Yaşı Yazma</option>
                    <option value="aciklama">Açıklama</option>
                    <option value="aciklama2">Açıklama 2</option>
                  </template>
                  <template v-if="model.SoftwareId == 9">
                    <option :value="null">Çocuk Yaşı Yazma</option>
                    <option value="R">Rezervasyon</option>
                    <option value="O">Ön Büro</option>
                    <option value="C">Check/Out</option>
                    <option value="H">HK</option>
                    <option value="W1">Konum Notu</option>
                    <option value="P">CRM</option>
                    <option value="D">Devremülk</option>
                    <option value="W">WEB(Online)</option>
                    <option value="R1">K. Uyuşmazlık</option>
                    <option value="J">Dock Kontrol</option>
                    <option value="U1">Fatura</option>
                  </template>
                  <template v-if="model.SoftwareId == 12">
                    <option :value="null">Çocuk Yaşı Yazma</option>
                    <option value="Note1">Not 1</option>
                    <option value="Note2">Not 2</option>
                  </template>
                  <template v-if="model.SoftwareId == 13">
                    <option :value="null">Çocuk Yaşı Yazma</option>
                    <option value="BillingInfo">Billing Info</option>
                    <option value="Remarks">Remarks</option>
                  </template>
                  <template v-if="model.SoftwareId == 14">
                    <option :value="null">Çocuk Yaşı Yazma</option>
                    <option value="Remark">Remark</option>
                    <option value="CheckInRemark">CheckInRemark</option>
                    <option value="CheckOutRemark">CheckOutRemark</option>
                    <option value="BlockageRemark">BlockageRemark</option>
                    <option value="FolioRemark">FolioRemark</option>
                  </template>
                  <template v-if="model.SoftwareId == 16">
                    <option :value="null">Çocuk Yaşı Yazma</option>
                    <option value="Remark">Remark</option>
                    <option value="CheckInRemark">CheckInRemark</option>
                    <option value="CheckOutRemark">CheckOutRemark</option>
                    <option value="BlockageRemark">BlockageRemark</option>
                    <option value="FolioRemark">FolioRemark</option>
                  </template>
                </template>
              </formGroup>
            </div>
            <div class="col">
              <formGroup
                v-if="
                  model.SoftwareId == 1 ||
                    model.SoftwareId == 2 ||
                    model.SoftwareId == 3 ||
                    model.SoftwareId == 5 ||
                    model.SoftwareId == 6 ||
                    model.SoftwareId == 7 ||
                    model.SoftwareId == 9 ||
                    model.SoftwareId == 11 ||
                    model.SoftwareId == 12 ||
                    model.SoftwareId == 13 ||
                    model.SoftwareId == 14 ||
                    model.SoftwareId == 16
                "
                as="select"
                class="focused"
                :title="'ChildAgesNotesLocation'"
                v-model="model.ChildAgesNotesLocation"
                :errors="errors"
                @keydown.enter="save"
                style="margin-bottom:-10px;"
              >
                <template #input>
                  <option value="before">Before</option>
                  <option value="after">After</option>
                </template>
              </formGroup>
            </div>
          </div>
          <template v-if="model.SoftwareId == 15">
            <form-group
              :title="'KolayrezNotesTo'"
              v-model="model.KolayrezNotesTo"
              :errors="errors"
            >
            </form-group>
          <div class="row">
            <div class="col">
              <formGroup
                :title="'ChildAgesNotesTo'"
                v-model="model.ChildAgesNotesTo"
                :errors="errors"
                @keydown.enter="save"
                style="margin-bottom:-10px;"
              >
              </formGroup>
            </div>
            <div class="col">
              <formGroup
                as="select"
                class="focused"
                :title="'ChildAgesNotesLocation'"
                v-model="model.ChildAgesNotesLocation"
                :errors="errors"
                @keydown.enter="save"
                style="margin-bottom:-10px;"
              >
                <template #input>
                  <option value="before">Before</option>
                  <option value="after">After</option>
                </template>
              </formGroup>
            </div>
          </div>
          </template>
          <div class="row justify-content-end">
            <div class="col-auto">
              <Btn
                class="btn-sm btn-info m-t-10 m-l-10"
                @click="refreshHotelMatchs"
                :disabled="processRefreshHotelMatchs"
                :process="processRefreshHotelMatchs"
                >Refresh Hotel Matchs</Btn
              >
            </div>
          </div>
          <div class="row justify-content-end" style="margin:0 -5px;">
            <div
              class="col-auto p-l-5 p-r-5 tright"
              v-if="model.SoftwareId == 7"
            >
              <Btn
                class="btn-sm btn-info m-t-10 m-l-10"
                @click="checkConnection"
                :disabled="processCheckConnection"
                :process="processCheckConnection"
                >Check Login</Btn
              >
            </div>
            <div
              class="col-auto p-l-5 p-r-5 tright"
              v-if="model.SoftwareId == 7"
            >
              <Btn
                class="btn-sm btn-info m-t-10 m-l-10"
                @click="statusService"
                :disabled="processStatusService"
                :process="processStatusService"
                >Status Service</Btn
              >
            </div>
            <div
              class="col-auto p-l-5 p-r-5 tright"
              v-if="model.SoftwareId == 7"
            >
              <Btn
                class="btn-sm btn-danger m-t-10 m-l-10"
                @click="restartService"
                :disabled="processRestartService"
                :process="processRestartService"
                >Restart Service</Btn
              >
            </div>
            <div
              class="col-auto p-l-5 p-r-5 tright"
              v-if="model.SoftwareId == 7"
            >
              <a
                target="_blank"
                :href="
                  'http://' +
                    model.P1 +
                    ':' +
                    model.P2 +
                    '/api/Model/GetModelByName?ModelName=Ulke'
                "
                class="btn btn-sm btn-success m-t-10 m-l-10"
                ><span>Test Link</span></a
              >
            </div>
            <div class="col-auto p-l-5 p-r-5 tright">
              <Btn
                class="btn-sm btn-success m-t-10 m-l-10"
                @click="test"
                :disabled="processTest"
                :process="processTest"
              >
                Test Connection</Btn
              >
            </div>
          </div>
          <div
            class="row justify-content-end"
            style="margin:0 -5px;"
            v-if="model.SoftwareId == 3"
          >
            <div class="col-auto p-l-5 p-r-5" v-if="setModel > 0">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="checkConnection"
                :disabled="processCheckConnection"
                :process="processCheckConnection"
                >Check Login</Btn
              >
            </div>
            <div class="col-auto p-l-5 p-r-5" v-if="setModel > 0">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="logout"
                :disabled="processLogout"
                :process="processLogout"
                >Logout</Btn
              >
            </div>
            <div class="col-auto p-l-5 p-r-5" v-if="setModel > 0">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="updateFormNeeds"
                :disabled="processUpdateFormNeeds"
                :process="processUpdateFormNeeds"
                >Update Form Needs</Btn
              >
            </div>
          </div>
          <div
            class="row justify-content-end"
            style="margin:0 -5px;"
            v-if="
              model.SoftwareId == 1 ||
                model.SoftwareId == 2 ||
                model.SoftwareId == 6
            "
          >
            <div
              class="col-auto p-l-5 p-r-5"
              v-if="setModel > 0 && model.SoftwareId == 6"
            >
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="checkConnection"
                :disabled="processCheckConnection"
                :process="processCheckConnection"
                >Check Login</Btn
              >
            </div>
            <div class="col-auto p-l-5 p-r-5" v-if="model.SoftwareId == 6">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="openTempReservation = true"
                >Temp Reservations</Btn
              >
            </div>
            <div class="col-auto p-l-5 p-r-5" v-if="setModel > 0">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="updateFormNeeds"
                :disabled="processUpdateFormNeeds"
                :process="processUpdateFormNeeds"
                >Update Form Needs</Btn
              >
            </div>
            <!-- <div class="col-auto p-l-5 p-r-5" v-if="setModel > 0">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="hotelSync"
                :disabled="processHotelSync"
                :process="processHotelSync"
                >Hotel Sync</Btn
              >
            </div> -->
            <!-- <div class="col-auto p-l-5 p-r-5" v-if="setModel > 0">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="sync"
                :disabled="processSync"
                :process="processSync"
                >Software Sync</Btn
              >
            </div> -->
          </div>
          <div
            class="row justify-content-end"
            style="margin:0 -5px;"
            v-if="model.SoftwareId == 5 || model.SoftwareId == 11"
          >
            <div class="col-auto p-l-5 p-r-5" v-if="setModel > 0">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="showGetCompanies = true"
                >Get Companies</Btn
              >
            </div>
            <div class="col-auto p-l-5 p-r-5" v-if="setModel > 0">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="updateFormNeeds"
                :disabled="processUpdateFormNeeds"
                :process="processUpdateFormNeeds"
                >Update Form Needs</Btn
              >
            </div>
          </div>
          <div
            class="row justify-content-end"
            style="margin:0 -5px;"
            v-if="model.SoftwareId == 7"
          >
            <div class="col-auto p-l-5 p-r-5">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="updateStopSales"
                :disabled="processUpdateStopSales"
                :process="processTest"
                >Update Stop Sales</Btn
              >
            </div>
            <div class="col-auto p-l-5 p-r-5" v-if="setModel > 0">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="updateFormNeeds"
                :disabled="processUpdateFormNeeds"
                :process="processUpdateFormNeeds"
                >Update Form Needs</Btn
              >
            </div>
          </div>
          <div
            class="row justify-content-end"
            style="margin:0 -5px;"
            v-if="model.SoftwareId == 3 || model.SoftwareId == 12"
          >
            <div class="col-auto p-l-5 p-r-5">
              <Btn class="btn-sm btn-primary m-t-10" @click="openSeasons = true"
                >Seasons</Btn
              >
            </div>
          </div>
          <div
            class="row justify-content-end"
            style="margin:0 -5px;"
            v-if="model.SoftwareId == 12"
          >
            <div class="col-auto p-l-5 p-r-5" v-if="setModel > 0">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="updateFormNeeds"
                :disabled="processUpdateFormNeeds"
                :process="processUpdateFormNeeds"
                >Update Form Needs</Btn
              >
            </div>
          </div>
          <div
            class="row justify-content-end"
            style="margin:0 -5px;"
            v-if="model.SoftwareId == 13"
          >
            <div class="col-auto p-l-5 p-r-5">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="openGreetingsDefaults = true"
                >Greetings Defaults</Btn
              >
            </div>
            <div class="col-auto p-l-5 p-r-5">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="openUnbillings = true"
                >Unbillings</Btn
              >
            </div>
            <div class="col-auto p-l-5 p-r-5">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="openTempReservation = true"
                >Temp Reservations</Btn
              >
            </div>
            <div class="col-auto p-l-5 p-r-5">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="openPartFormNeedsUpdate = true"
                >Update Form Needs</Btn
              >
            </div>
          </div>
          <div
            class="row justify-content-end"
            style="margin:0 -5px;"
            v-if="model.SoftwareId == 9"
          >
            <div class="col-auto p-l-5 p-r-5">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="openPartFormNeedsUpdate = true"
                >Update Form Needs</Btn
              >
            </div>
            <div class="col-auto p-l-5 p-r-5">
              <Btn
                class="btn-sm btn-primary m-t-10"
                :disabled="processRmosLogin"
                :process="processRmosLogin"
                @click="rmosLogin"
                >Login</Btn
              >
            </div>
          </div>
          <div
            class="row justify-content-end"
            style="margin:0 -5px;"
            v-if="model.SoftwareId == 15"
          >
            <div class="col-auto p-l-5 p-r-5">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="openPartFormNeedsUpdate = true"
                >Update Form Needs</Btn
              >
            </div>
            <div class="col-auto p-l-5 p-r-5">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="openCurrencies = true"
                >Currencies</Btn
              >
            </div>
            <div class="col-auto p-l-5 p-r-5">
              <Btn
                class="btn-sm btn-primary m-t-10"
                :disabled="processResortManagerLogin"
                :process="processResortManagerLogin"
                @click="resortManagerLogin"
                >Login</Btn
              >
            </div>
          </div>
          <div
            class="row justify-content-end"
            style="margin:0 -5px;"
            v-if="model.SoftwareId == 16"
          >
            <div class="col-auto p-l-5 p-r-5">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="openPartFormNeedsUpdate = true"
                >Update Form Needs</Btn
              >
            </div>
            <div class="col-auto p-l-5 p-r-5">
              <Btn
                class="btn-sm btn-primary m-t-10"
                :disabled="processVeboniLogin"
                :process="processVeboniLogin"
                @click="veboniLogin"
                >Login</Btn
              >
            </div>
          </div>
          <div
            class="row justify-content-end"
            style="margin:0 -5px;"
            v-if="model.SoftwareId == 10"
          >
            <div class="col-auto p-l-5 p-r-5">
              <Btn
                class="btn-sm btn-primary m-t-10"
                @click="openPartFormNeedsUpdate = true"
                >Update Form Needs</Btn
              >
            </div>
            
          </div>
        </div>
        <div
          class="col-12"
          v-if="
            model.SoftwareId == 1 ||
              model.SoftwareId == 2 ||
              model.SoftwareId == 5 ||
              model.SoftwareId == 11
          "
        >
          <div id="accordian-3" class="fleft w100 m-t-10">
            <div class="card m-b-0">
              <div class="card-header">
                <formGroup
                  :title="'PdfDownload'"
                  :as="'checkbox'"
                  v-model="model.PdfDownload"
                  :errors="errors"
                  @keydown.enter="save"
                ></formGroup>
              </div>
              <div class="collapse show" v-if="model.PdfDownload">
                <div class="card-header p-t-0">
                  <formGroup
                    :title="'PdfPath'"
                    v-model="model.PdfPath"
                    :rules="{ required: true, max: 500 }"
                    :errors="errors"
                    @keydown.enter="save"
                  ></formGroup>
                  <formGroup
                    :title="'PdfUrl'"
                    v-model="model.PdfUrl"
                    :rules="{ required: true, max: 500 }"
                    :errors="errors"
                    @keydown.enter="save"
                  ></formGroup>
                  <formGroup
                    :title="'NetworkAppPath'"
                    v-model="model.NetworkAppPath"
                    :errors="errors"
                    @keydown.enter="save"
                  ></formGroup>
                  <formGroup
                    :title="'NetworkReservationPath'"
                    v-model="model.NetworkReservationPath"
                    :errors="errors"
                    @keydown.enter="save"
                  ></formGroup>
                  <formGroup
                    :title="'NetworkUsername'"
                    v-model="model.NetworkUsername"
                    :errors="errors"
                    @keydown.enter="save"
                  ></formGroup>
                  <formGroup
                    :title="'NetworkPassword'"
                    v-model="model.NetworkPassword"
                    :errors="errors"
                    @keydown.enter="save"
                  ></formGroup>
                  <div class="tright">
                    <Btn
                      class="btn-sm btn-success"
                      @click="downloader"
                      :disabled="processDownloader"
                      :process="processDownloader"
                      >Test Downloader</Btn
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </template>
    <template #foot>
      <Btn
        class="btn-success btn-md"
        @click="save"
        :disabled="
          hotels == null ||
            softwares == null ||
            countries == null ||
            load ||
            process
        "
        :process="process"
        >{{
          setModel > 0 ? "Update Customer Hotel" : "Add Customer Hotel"
        }}</Btn
      >
    </template>
  </modal>
  <addSoftware
    v-if="addSoftwareOpen"
    @close="addSoftwareOpen = false"
    @add="data.push($event)"
  ></addSoftware>
  <getCompanies
    v-if="showGetCompanies"
    :model="model"
    @selectCompany="
      model.P6 = $event.RecId;
      model.P7 = $event.CompanyCode;
      showGetCompanies = false;
    "
    @close="showGetCompanies = false"
  ></getCompanies>
  <seasons
    v-if="openSeasons"
    @close="openSeasons = false"
    :hotelId="setModel"
  ></seasons>
  <tempReservation
    v-if="openTempReservation"
    :hotel="model"
    @close="openTempReservation = false"
  >
  </tempReservation>
  <partFormNeedsUpdate
    v-if="openPartFormNeedsUpdate"
    :hotel="model"
    @close="openPartFormNeedsUpdate = false"
  >
  </partFormNeedsUpdate>
  <fidelioGreetingsDefault
    v-if="openGreetingsDefaults && !load"
    @close="openGreetingsDefaults = false"
    :hotel="model"
  ></fidelioGreetingsDefault>
  <unbillings
    v-if="openUnbillings"
    @close="openUnbillings = false"
    :hotelId="setModel"
  >
  </unbillings>
  <currencies
    v-if="openCurrencies"
    @close="openCurrencies = false"
    :hotelId="setModel"
  >
  </currencies>
</template>

<script>
import selectBox from "@/components/formGroup/selectBox";
import addSoftware from "@/views/softwares/upsert";
import getCompanies from "./getComponies.vue";
import seasons from "./seasons/main.vue";
import tempReservation from "./tempReservaitons/main.vue";
import partFormNeedsUpdate from "./partFormNeedsUpdate/main.vue";
import fidelioGreetingsDefault from "./fidelioGreetingsDefault.vue";
import unbillings from "./unbillings/main.vue";
import currencies from "./currencies/main.vue";
import axios from "axios";
export default {
  props: {
    setModel: Object,
    CustomerId: Number,
  },
  components: {
    selectBox,
    addSoftware,
    getCompanies,
    seasons,
    tempReservation,
    partFormNeedsUpdate,
    fidelioGreetingsDefault,
    unbillings,
    currencies,
  },
  data() {
    return {
      load: false,
      addSoftwareOpen: false,
      model: {
        Id: null,
        CustomerId: this.CustomerId,
        HotelId: "",
        RoomCount: null,
        ChildPercentage:0.5,
        PMSIntegration: true,
        SoftwareId: null,
        P1: "",
        P2: "",
        P3: "",
        P4: "",
        P5: "",
        P6: "",
        P7: "",
        P8: "",
        P9: "",
        P10: "",
        P11: "",
        P12: "",
        P13: "",
        P14: "",
        P15: "",
        P16: "",
        P17: "",
        P18: "",
        P19: "",
        P20: "",
        EnterHour: "",
        EnterMinute: "",
        ExitHour: "",
        ExitMinute: "",
        AddinationalArrivalHour: "",
        AddinationalArrivalMinute: "",
        AddinationalDepartureHour: "",
        AddinationalDepartureMinute: "",
        TempReservationCode: "",
        KolayrezNotesTo: null,
        ChildAgesNotesTo: null,
        ChildAgesNotesLocation: "after",

        PdfDownload: false,
        PdfPath: "",
        PdfUrl: "",
        Mr: "",
        Mrs: "",
        Chd: "",
        Inf: "",

        RemoveOldReservations: false,
        RemoveOldReservationsHour: 0,

        NetworkAppPath: "",
        NetworkReservationPath: "",
        NetworkUsername: "",
        NetworkPassword: "",

        AutoRepeat: false,

        AutoCountrySelection: true,

        OrderPersonNames: true,

        CheckRepeat: true,
        ShowDiscountCode: false,
        SaleClock: false,
        AdultAgeEdit: false,
        AdultAgeFrom: "checkin",
        AdultAgeFromDays: null,
        ChildAgeEdit: false,
        ChildAgeFrom: "checkin",
        ChildAgeFromDays: null,

        OrderContract: false,

        AgeCalculation: true,

        TempGuestCode: null,

        UsePerspectiva: false,

        ArrivalHourTo: 0,
        DepartureHourTo: 0,

        QuotaType: 3,

        WaitApproveConfirmAgency: false,
        WaitApproveSavePMS: false,

        SendApproveBeforeSave: true,
        SendApproveAfterSave: true,

        UseStopSale: true,

        DefaultQuotaMarket: 1,
        WriteConfirmedDocument: false,
        SaveConfirmedDocument: false,

        CustomConfig: null,

        GroupCheckRepeat: true,

        AutoSave: false,

        FileNameFormat: null,
      },
      hotels: null,
      searchHotel: "",
      softwares: null,
      countries: null,
      countryId: 228,
      process: false,
      processTest: false,
      processSync: false,
      processHotelSync: false,
      processUpdateFormNeeds: false,
      processUpdateStopSales: false,
      processDownloader: false,
      asyaStatus: "",
      processRestartService: false,
      processStatusService: false,
      showGetCompanies: false,
      processCheckConnection: false,
      sednaCompanies: null,
      sednaCompaniesLoad: false,
      openSeasons: false,
      refleshRoomCountProcess: false,
      openTempReservation: false,
      openPartFormNeedsUpdate: false,
      processRefreshHotelMatchs: false,
      openGreetingsDefaults: false,
      processRmosLogin: false,
      openRoutingNotes: null,
      processResortManagerLogin: false,
      openUnbillings: false,
      processVeboniLogin: false,
      processLogout:false,
      processVeboniProperty:false,
      veboniProperties: [],
      openCurrencies:false
      
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Hotels/Country/228`).then((response) => {
      this.hotels = response.data;
      if (this.setModel > 0 && this.hotels != null) {
        this.hotels.forEach((element) => {
          if (element.Id == this.model.HotelId) {
            this.countryId = element.CountryId;
          }
        });
      }
    });
    this.$appAxiosAdmin.get(`Softwares`).then((response) => {
      this.softwares = response.data;
    });
    this.$appAxiosAdmin.get(`Countries`).then((response) => {
      this.countries = response.data;
    });
    this.get();
  },
  methods: {
    get() {
      if (this.setModel > 0) {
        this.load = true;
        this.$appAxiosAdmin.get(`Hotels/` + this.setModel).then((response) => {
          this.model = { ...response.data, HotelId: response.data.Id };
          if (this.setModel > 0 && this.hotels != null) {
            this.hotels.forEach((element) => {
              if (element.Id == this.model.HotelId) {
                this.countryId = element.CountryId;
              }
            });
          }
          this.getSednaCompanies();
          this.getVeboniProperty();
          // if(this.model.SoftwareId==7){
          //   axios.get("http://"+this.model.P1+":"+this.model.P2+"/tool/asya2web/tool.srf?STATUS="+this.model.P2).then(rsp=>{
          //     console.log("STATUS",rsp);
          //   }).catch(err=>{
          //     this.asyaStatus="<strong>Hata</strong>"+err?.response?.data!=undefined && err?.response?.data!=""?err?.response?.data:err?.response?.statusText;
          //     // asyaStatus
          //   });
          // }
          this.load = false;
        });
      }
    },
    refleshRoomCount() {
      this.refleshRoomCountProcess = true;
      let url="PMS/RoomCount/"
      if(this.model.SoftwareId==9){
        url="pms/"+this.model.SoftwareId+"/RoomCount/"
      }
      this.$appAxiosAdmin
        .get(url + this.setModel)
        .then((response) => {
          this.model.RoomCount = response.data;
          this.refleshRoomCountProcess = false;
        })
        .catch(() => {
          this.refleshRoomCountProcess = false;
        });
    },
    rmosLogin() {
      this.processRmosLogin = true;
      this.$appAxiosAdmin
        .get(`pms/9/Login/` + this.setModel)
        .then(() => {
              this.$swal({
                icon: "success",
                title: "Success",
                text:"The customer hotel has been successfully login.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
          this.get();
          this.processRmosLogin = false;
        })
        .catch((err) => {
          this.processRmosLogin = false;
          this.$isError(err);
        });
    },
    resortManagerLogin() {
      this.processResortManagerLogin = true;
      this.$appAxiosAdmin
        .post(`pms/15/TestLogin`, {
          SoftwareId: 15,
          HotelId: this.setModel,
          P1: this.model.P1,
          P2: this.model.P2,
          P3: this.model.P3,
          P4: this.model.P4,
          P5: this.model.P5,
          P6: this.model.P6,
          P7: this.model.P7,
          P8: this.model.P8,
          P9: this.model.P9,
          P10: this.model.P10,
          P11: this.model.P11,
          P12: this.model.P12,
          P13: this.model.P13,
          P14: this.model.P14,
          P15: this.model.P15,
          P16: this.model.P16,
          P17: this.model.P17,
          P18: this.model.P18,
          P19: this.model.P19,
          P20: this.model.P20,
        })
        .then(() => {
              this.$swal({
                icon: "success",
                title: "Success",
                text:"The customer hotel has been successfully login.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
          this.get();
          this.processResortManagerLogin = false;
        })
        .catch((err) => {
          this.processResortManagerLogin = false;
          this.$isError(err);
        });
    },
    veboniLogin() {
      this.processVeboniLogin = true;
      this.$appAxiosAdmin
        .get(`pms/16/login/`+this.setModel)
        .then(() => {
              this.$swal({
                icon: "success",
                title: "Success",
                text:"The customer hotel has been successfully login.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
          this.get();
          this.processVeboniLogin = false;
        })
        .catch((err) => {
          this.processVeboniLogin = false;
          this.$isError(err);
        });
    },
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;

          this.model.NetworkAppPath =
            this.model.NetworkAppPath == "" ? null : this.model.NetworkAppPath;
          this.model.NetworkReservationPath =
            this.model.NetworkReservationPath == ""
              ? null
              : this.model.NetworkReservationPath;
          this.model.NetworkUsername =
            this.model.NetworkUsername == ""
              ? null
              : this.model.NetworkUsername;
          this.model.NetworkPassword =
            this.model.NetworkPassword == ""
              ? null
              : this.model.NetworkPassword;
          this.model.TempGuestCode =
            this.model.TempGuestCode != null &&
            this.model.TempGuestCode.trim() == ""
              ? null
              : this.model.TempGuestCode;
          this.$appAxiosAdmin
            .put(`CustomerHotels`, {
              ...this.model,
              EnterHour:
                this.model.EnterHour == "" ? null : this.model.EnterHour,
              EnterMinute:
                this.model.EnterMinute == "" ? null : this.model.EnterMinute,
              ExitHour: this.model.ExitHour == "" ? null : this.model.ExitHour,
              ExitMinute:
                this.model.ExitMinute == "" ? null : this.model.ExitMinute,
              FileNameFormat:
                this.model.FileNameFormat==null || this.model.FileNameFormat.trim() == ""
                  ? null
                  : this.model.FileNameFormat.trim(),
            })
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The customer hotel has been successfully updated."
                    : "The customer hotel has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel > 0) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
    restartService() {
      this.processRestartService = true;
      axios
        .get(
          "http://" +
            this.model.P1 +
            ":" +
            this.model.P2 +
            "/tool/asya2web/tool.srf?RESTARTWEBAPI=" +
            this.model.P2
        )
        .then(() => {
          this.processRestartService = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text:
              "Successfully restart the services. It will be ready in 5 minutes.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.processRestartService = false;
          this.$isError(err);
        });
    },
    statusService() {
      this.processStatusService = true;
      axios
        .get(
          "http://" +
            this.model.P1 +
            ":" +
            this.model.P2 +
            "/tool/asya2web/tool.srf?STATUSWEBAPI=" +
            this.model.P2
        )
        .then((rsp) => {
          this.processStatusService = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: rsp.data,
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.processStatusService = false;
          this.$isError(err);
        });
    },
    async test() {
      if (this.model.SoftwareId == 9) {
        this.processTest = true;
        const completed = [];
        let randomTag = null;
        try {
          await this.$appAxiosAdmin.get(`pms/9/Login/` + this.setModel);
          completed.push("Login");

          const partsRes = await this.$appAxiosAdmin.get(`Softwares/9/FormParts`);
          const parts = partsRes.data;
          if (!parts || !parts.length) throw new Error("FormParts list is empty");
          randomTag = parts[Math.floor(Math.random() * parts.length)].Tag;
          completed.push("Form Parts");

          await this.$appAxiosAdmin.get(`pms/9/UpdateFormPart/` + this.setModel + `/` + randomTag);
          completed.push("Update Form Part (" + randomTag + ")");

          this.$swal({
            icon: "success",
            title: "Test Connection Successful",
            html: completed.map((s) => "✓ " + s).join("<br>"),
            timer: 6000,
            confirmButtonText: "Okey",
          });
        } catch (err) {
          const stepNames = [
            "Login",
            "Form Parts",
            "Update Form Part" + (randomTag ? " (" + randomTag + ")" : ""),
          ];
          const failedStep = stepNames[completed.length] ?? "Unknown";
          this.$swal({
            icon: "error",
            title: "Test Connection Failed",
            html: [
              ...completed.map((s) => "✓ " + s),
              "✗ " + failedStep,
            ].join("<br>"),
            confirmButtonText: "Okey",
          });
        } finally {
          this.processTest = false;
        }
        return;
      }
      this.processTest = true;
      let url = "PMS/TestConnection";
      if (this.model.SoftwareId == 12) {
        url = "PMS/12/TestConnection";
      }
      if (this.model.SoftwareId == 13) {
        url = "PMS/13/TestConnection";
      }
      this.$appAxiosAdmin
        .post(url, {
          SoftwareId: this.model.SoftwareId,
          CustomerId: this.model.CustomerId,
          P1: this.model.P1,
          P2: this.model.P2,
          P3: this.model.P3,
          P4: this.model.P4,
          P5: this.model.P5,
          P6: this.model.P6,
          P7: this.model.P7,
          P8: this.model.P8,
          P9: this.model.P9,
          P10: this.model.P10,
          P11: this.model.P11,
          P12: this.model.P12,
          P13: this.model.P13,
          P14: this.model.P14,
          P15: this.model.P15,
          P16: this.model.P16,
          P17: this.model.P17,
          P18: this.model.P18,
          P19: this.model.P19,
          P20: this.model.P20,
          // this.model
        })
        .then(() => {
          this.processTest = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully connected.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.processTest = false;
          this.$isError(err);
        });
    },
    getSednaCompanies() {
      if (this.model.SoftwareId != 5 && this.model.SoftwareId != 11) {
        this.sednaCompaniesLoad = false;
        return false;
      }
      this.sednaCompaniesLoad = true;
      this.sednaCompanies = null;
      this.$appAxiosAdmin
        .post(`PMS/Sedna/Companies`, {
          SoftwareId: this.model.SoftwareId,
          CustomerId: this.model.CustomerId,
          P1: this.model.P1,
          P2: this.model.P2,
          P3: this.model.P3,
          P4: this.model.P4,
          P5: this.model.P5,
          P6: this.model.P6,
          P7: this.model.P7,
          P8: this.model.P8,
          P9: this.model.P9,
          P10: this.model.P10,
          P11: this.model.P11,
          P12: this.model.P12,
          P13: this.model.P13,
          P14: this.model.P14,
          // this.model
        })
        .then((res) => {
          this.sednaCompanies = res.data;
          this.sednaCompaniesLoad = false;
        })
        .catch((err) => {
          this.sednaCompaniesLoad = false;
          this.$isError(err);
        });
    },
    downloader() {
      this.processDownloader = true;
      this.$appAxiosAdmin
        .get(`Hotels/DownloaderTest/` + this.setModel)
        .then(() => {
          this.processDownloader = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully downloader.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          console.log(err?.response?.statusText);
          this.processDownloader = false;
          this.$isError(err);
        });
    },
    sync() {
      this.processSync = true;
      this.$appAxiosAdmin
        .get(`PMS/SoftwareSync/` + this.setModel)
        .then(() => {
          this.processSync = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully software sync.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.processSync = false;
          this.$isError(err);
        });
    },
    updateStopSales() {
      this.processUpdateStopSales = true;
      this.$appAxiosAdmin
        .get(`PMS/UpdateStopSales/` + this.setModel)
        .then(() => {
          this.processUpdateStopSales = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully update stop sales.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.processUpdateStopSales = false;
          this.$isError(err);
        });
    },
    hotelSync() {
      this.processHotelSync = true;
      this.$appAxiosAdmin
        .get(`PMS/HotelSync/` + this.setModel)
        .then(() => {
          this.processHotelSync = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully hotel sync.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.processHotelSync = false;
          this.$isError(err);
        });
    },
    updateFormNeeds() {
      this.processUpdateFormNeeds = true;
      let url = `PMS/UpdateFormNeeds/` + this.setModel;
      if (this.model.SoftwareId == 12) {
        url = `PMS/12/UpdateReservationDetailFormNeeds/` + this.setModel;
      }
      this.$appAxiosAdmin
        .get(url)
        .then(() => {
          this.processUpdateFormNeeds = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully update form needs.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.processUpdateFormNeeds = false;
          this.$isError(err);
        });
    },
    checkConnection() {
      this.processCheckConnection = true;
      this.$appAxiosAdmin
        .get(`PMS/CheckConnection/` + this.setModel)
        .then(() => {
          this.processCheckConnection = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully check login.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.processCheckConnection = false;
          this.$isError(err);
        });
    },
    logout() {
      this.processLogout = true;
      this.$appAxiosAdmin
        .get(`PMS/DiaLogout/` + this.setModel)
        .then(() => {
          this.processLogout = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully logout.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.processLogout = false;
          this.$isError(err);
        });
    },
    refreshHotelMatchs() {
      this.processRefreshHotelMatchs = true;
      this.$appAxiosAdmin
        .get(`Hotels/` + this.setModel + "/RefreshHotelMatchs")
        .then(() => {
          this.processRefreshHotelMatchs = false;
          this.$swal({
            icon: "success",
            title: "Success",
            text: "Successfully refresh hotel matchs.",
            timer: 2000,
            confirmButtonText: "Okey",
          });
        })
        .catch((err) => {
          this.processRefreshHotelMatchs = false;
          this.$isError(err);
        });
    },
    getVeboniProperty() {
      if (this.model.SoftwareId != 16 || this.model.P4 == null || this.model.P4.trim() == "") {
        this.processVeboniProperty = false;
        return false;
      }
      this.processVeboniProperty = true;
      this.veboniProperties = [];
      this.$appAxiosAdmin
        .post(`PMS/16/Properties`, {
          Token: this.model.P4,
          HotelId:this.setModel
        })
        .then((res) => {
          this.veboniProperties = res.data;
          this.processVeboniProperty = false;
        })
        .catch((err) => {
          this.processVeboniProperty = false;
          this.$isError(err);
        });
    },
  },
  computed: {
    setParamterText() {
      return (pName) => {
        if (this.model.SoftwareId == 1 || this.model.SoftwareId == 2) {
          if (pName == "P1") {
            return "IP";
          }
          if (pName == "P2") {
            return "Database Name";
          }
          if (pName == "P3") {
            return "Username";
          }
          if (pName == "P4") {
            return "Password";
          }
          if (pName == "P5") {
            return "Port";
          }
        }
        if (this.model.SoftwareId == 3) {
          if (pName == "P1") {
            return "Server";
          }
          if (pName == "P2") {
            return "Username";
          }
          if (pName == "P3") {
            return "Password";
          }
          if (pName == "P4") {
            return "Firma Kodu";
          }
          if (pName == "P5") {
            return "Dönem Kodu";
          }
          if (pName == "P6") {
            return "Auth Key";
          }
        }
        if (this.model.SoftwareId == 7) {
          if (pName == "P1") {
            return "API URL";
          }
          if (pName == "P2") {
            return "Port";
          }
          if (pName == "P3") {
            return "Ref ID";
          }
        }
        if (this.model.SoftwareId == 6) {
          if (pName == "P1") {
            return "Hotel Code";
          }
          if (pName == "P2") {
            return "Username";
          }
          if (pName == "P3") {
            return "Password";
          }
          if (pName == "P4") {
            return "Token";
          }
          if (pName == "P8") {
            return "Hotel  Name";
          }
          if (pName == "P15") {
            return "Temp Rez C/in Date";
          }
          if (pName == "P16") {
            return "Temp Rez Stay Days";
          }
        }
        if (this.model.SoftwareId == 8) {
          if (pName == "P1") {
            return "IP";
          }
          if (pName == "P2") {
            return "Port";
          }
          if (pName == "P3") {
            return "Username";
          }
          if (pName == "P4") {
            return "Password";
          }
        }
        if (this.model.SoftwareId == 5 || this.model.SoftwareId == 11) {
          if (pName == "P1") {
            return "IP";
          }
          if (pName == "P2") {
            return "Database Name";
          }
          if (pName == "P3") {
            return "Username";
          }
          if (pName == "P4") {
            return "Password";
          }
          if (pName == "P5") {
            return "Port";
          }
          if (pName == "P6") {
            return "CompanyRecId";
          }
          if (pName == "P7") {
            return "CompanyCode";
          }
          if (pName == "P8") {
            return "Service";
          }
          if (pName == "P9") {
            return "ServiceUrl";
          }
          if (pName == "P10") {
            return "Local IP";
          }
          if (pName == "P11") {
            return "Local Port";
          }
          if (pName == "P12") {
            return "PdfType";
          }
          if (pName == "P13") {
            return "ForecastModel";
          }
        }
        if (this.model.SoftwareId == 13) {
          if (pName == "P1") {
            return "Service Url";
          }
          if (pName == "P2") {
            return "Hotel Cod";
          }
          if (pName == "P3") {
            return "UserName";
          }
          if (pName == "P4") {
            return "Password";
          }
          if (pName == "P5") {
            return "TempReservation RateCod";
          }
          if (pName == "P6") {
            return "TempReservation CheckIn";
          }
          if (pName == "P7") {
            return "TempReservation MarketCode";
          }
          if (pName == "P8") {
            return "TempReservation RoomTypeCode";
          }
          if (pName == "P9") {
            return "TempReservation SourceCod";
          }
          if (pName == "P10") {
            return "TempReservation ProfileId";
          }
          if (pName == "P11") {
            return "DocumentGroupId";
          }
          if (pName == "P12") {
            return "Web Enabled";
          }
          if (pName == "P13") {
            return "Perspectiva Url";
          }
          if (pName == "P14") {
            return "Perspectiva ConnectionString";
          }
        }
        if (this.model.SoftwareId == 9) {
          if (pName == "P1") {
            return "Kullanıcı";
          }
          if (pName == "P2") {
            return "Şifre";
          }
          if (pName == "P3") {
            return "Database ID";
          }
          if (pName == "P4") {
            return "Token";
          }
        }
        if (this.model.SoftwareId == 16) {
          if(this.model.P20=='appkey'){
             if (pName == "P1") {
                return "App Key"
              }
              if (pName == "P2") {
                return "P2";
              }
          }
          if (pName == "P1") {
            return "Username"
          }
          if (pName == "P2") {
            return "Password";
          }
          if (pName == "P3") {
            return "Property";
          }
          if (pName == "P4") {
            return "Token";
          }
          if (pName == "P5") {
            return "Tenant Id";
          }
          if (pName == "P20") {
            return "Is App Key";
          }
        }
        return pName;
      };
    },
  },
};
</script>

<style scoped>
.row {
  margin: 0 * 5px;
}

.row > div {
  padding: 0 5px;
}
</style>
